import { makeObservable } from "mobx";
import { BaseCategoryViewStore } from "application/categories/stores";
import { nakiRadioSystemTypes, podcastCategory, userDeviceBulkContentType } from "common/constants";
import { homeContentType } from "application/common/content-access";

class PodcastsViewStore extends BaseCategoryViewStore {
    constructor(rootStore, { routeStore }) {
        super(rootStore);
        this.category = podcastCategory.podcast;
        this.contentType = userDeviceBulkContentType.podcasts;
        makeObservable(this);
        this.routeStore = routeStore;
        this.queryUtility.filter.set("category", this.category);

        this.reaction(
            () => this.rootStore.userDeviceStore.selectedDevice,
            (selectedDevice) => {
                const selectedDeviceSystemType = selectedDevice?.device?.systemType?.abrv;
                if (selectedDeviceSystemType === nakiRadioSystemTypes.mobile_restricted || selectedDeviceSystemType === nakiRadioSystemTypes.mobile_handheld ||
                    selectedDeviceSystemType === nakiRadioSystemTypes.mobile_handheld_pink) {
                    this.rootStore.routerStore.goTo("master.application.categories.stories");
                }
            }
        );
    }

    find(params) {
        if (this.selectedDevice) {
            params.deviceId = this.selectedDevice.id;
        }
        return this.routeStore.find(params);
    }

    search(params) {
        params.category = this.category;
        params.contentType = homeContentType.podcast;
        return this.routeStore.search(params);
    }
}

export default PodcastsViewStore;
